/* eslint-disable class-methods-use-this */
import * as api from '../../../utils/apiClient';

class PaymentsService {
  async createPayment(state, body) {
    const response = await api.post('/payments', {}, body);
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new PaymentsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/services/PaymentsService.js